import React from 'react';

import { Grid, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface GridItemProps {
  title: string | number | undefined | React.ReactNode;
  seenOrIsHeading: boolean;
  breakpoint: number;
  message?: string;
  textColor?: string;
  customStyles?: React.CSSProperties;
}

const GridItem = ({ title, seenOrIsHeading, breakpoint, message, textColor, customStyles }: GridItemProps) => {
  const theme = useTheme();

  return (
    <Grid
      item
      md={breakpoint}
      sm={breakpoint}
      xs={breakpoint}
      sx={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        justifyContent: 'center',
      }}>
      <Typography
        sx={{
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          color: textColor || (seenOrIsHeading ? theme.palette.text.disabled : theme.palette.text.primary),
          paddingInlineStart: theme.spacing(2),
          textJustify: 'center',
          ...customStyles,
        }}
        variant={seenOrIsHeading ? 'body2' : 'subtitle1'}>
        {title}
      </Typography>
      {message && (
        <Typography
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            color: seenOrIsHeading ? theme.palette.text.disabled : theme.palette.text.primary,
            paddingInlineStart: theme.spacing(2),
            maxHeight: '100%',
          }}
          variant={seenOrIsHeading ? 'body2' : 'body1'}>
          {message}
        </Typography>
      )}
    </Grid>
  );
};

export default GridItem;
